const styles = ({ COLORS }) => ({
  valueStyles: {
    color: COLORS.TEXT.MID_GREY.NORMAL,
    left: '0',
    top: '0',
    width: 'calc(100% - 30px)',
    height: '100%',
    lineHeight: '40px',
    position: 'absolute',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '0 0 0 15px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderRight: '1px solid #ddd'
  },
  select: {
    position: 'relative',
    '& .Select-control': {
      overflow: 'hidden',
      height: '40px',
      lineHeight: '40px',
      border: '1px solid #DDD',
      borderRadius: '4px',
      backgroundColor: '#fff',
      position: 'relative',
      cursor: 'pointer'
    },
    '& .Select-input': {
      display: 'none'
    },
    '& .Select-placeholder': {
      extend: 'valueStyles'
    },
    '& .Select-arrow-zone': {
      position: 'absolute',
      right: '0',
      top: '0',
      width: '22px'
    },
    '& .Select-menu-outer': {
      maxHeight: '200px',
      position: 'absolute',
      top: '100%',
      width: '100%',
      zIndex: '1'
    },
    '& .Select-menu': {
      maxHeight: '200px',
      overflowY: 'auto',
      border: '1px solid #DDD',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#fff',
      borderRadius: '4px',
      overflow: 'hidden',
      marginTop: '4px',
      color: COLORS.TEXT.LIGHT_GREY.NORMAL
    },
    '& .Select-noresults': {
      padding: '5px 15px'
    },
    '& .Select-option.is-selected > span': {
      color: COLORS.BLUE.NORMAL
    }
  },
  value: {
    extend: 'valueStyles'
  },
  option: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '5px 15px',
    '&:hover': {
      color: COLORS.BLUE.NORMAL
    }
  },
  oddOption: {
    backgroundColor: '#f9f9f9'
  },
  buttonIcon: {
    color: '#787878'
  }
})

export default styles
